import {SkeletonBox} from '@primer/react'

import styles from './CopilotPlansExperimentSkeleton.module.css'

const skeletonCards = Array.from({length: 4}, (_, index) => index)
const skeletonFeatures = Array.from({length: 4}, (_, index) => index)

export function CopilotPricingCardsSkeleton() {
  return (
    <div className={styles.PricingSurface} aria-hidden="true">
      <div className={styles.PricingLabels}>
        {skeletonCards.map(card => (
          <div className={styles.PricingLabelCell} key={card}>
            {card === skeletonCards.length - 1 ? <SkeletonBox className={styles.Label} width="45%" /> : null}
          </div>
        ))}
      </div>
      <div className={styles.PricingGrid}>
        {skeletonCards.map(card => (
          <div className={styles.PricingCard} key={card}>
            <SkeletonBox className={styles.Title} width="70%" />
            <SkeletonBox className={styles.Description} width="100%" />
            <SkeletonBox className={styles.Price} width="55%" />
            <SkeletonBox className={styles.Cta} width="100%" />
            <div className={styles.Features}>
              <SkeletonBox className={styles.FeatureHeading} width="50%" />
              {skeletonFeatures.map(feature => (
                <SkeletonBox className={styles.Feature} key={feature} width={feature % 2 === 0 ? '90%' : '75%'} />
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  )
}

export function CopilotPlansExperimentSkeleton() {
  return (
    <section className={styles.CopilotPlansExperimentSkeleton} aria-hidden="true">
      <div className={styles.Heading}>
        <SkeletonBox width="100%" height="100%" />
      </div>
      <div className={styles.PlanTypeControl}>
        <SkeletonBox width="100%" height="100%" />
      </div>
      <CopilotPricingCardsSkeleton />
      <div className={styles.SupportingContent}>
        <SkeletonBox className={styles.SupportingText} width="35%" />
        <SkeletonBox className={styles.IdeList} width="100%" />
      </div>
    </section>
  )
}
